@if (toast) {
  <nes-message-toast
    [active]="true"
    [label]="toast.label"
    auto-hide="true"
    (nesOnHideComplete)="onHide()"
  ></nes-message-toast>
}
